import { render } from "./PendingPayments.vue?vue&type=template&id=1b9e6e30"
import script from "./PendingPayments.vue?vue&type=script&lang=js"
export * from "./PendingPayments.vue?vue&type=script&lang=js"

import "./PendingPayments.vue?vue&type=style&index=0&id=1b9e6e30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__